import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const stats = [
   { value: '50', label: 'Projects\nDelivered' },
   { value: '20', label: 'Clients\nServed' },
   { value: '7', label: 'Industries' },
   { value: '20+', label: 'Years of Collective\nExperience' },
];

const MetricsShowcase = () => {
   return (
      <section className="metrics-showcase pb-20">
         <div className="tw-container tw-mx-auto">
            <div className="tw-flex tw-flex-wrap tw--mx-3 metrics-showcase__stats">
               {stats.map((stat, index) => (
                  <div key={index} className="tw-w-1/2 tw-px-3 lg:tw-w-1/4 tw-mb-6 lg:tw-mb-0">
                     <div className="metrics-showcase__stat">
                        <span className="metrics-showcase__stat-number">{stat.value}</span>
                        <span className="metrics-showcase__stat-label">{stat.label}</span>
                     </div>
                  </div>
               ))}
            </div>

            <div className="metrics-showcase__banner" style={{ backgroundImage: `url(assets/img/about/harsogt_ourStory_bg.png)`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
               <span className="metrics-showcase__banner-icon" aria-hidden="true">
                  <img src="assets/img/logo/harsoft_logo_icon_svg.svg" alt="" />
               </span>
               <div className="metrics-showcase__banner-content">
                  <h3 className="metrics-showcase__banner-title">Helping Ambitious Teams Build, Automate, and Grow</h3>
                  <Link to="/contact" className="btn-more">
                     <span className="btn-text">Work with us</span>
                     <span className="btn-icon" aria-hidden="true">
                        <ArrowUpRight size="16px" className="icon" />
                     </span>
                  </Link>
               </div>
            </div>
         </div>
      </section>
   );
};

export default MetricsShowcase;
